type SocialNetworkContainerProps = { children: React.ReactNode };

const SocialNetworkContainer = ({ children }: SocialNetworkContainerProps) => {
	return <div className={`vtex-store-footer-2-x-socialNetworksContainer nh2 flex`}>{children}</div>;
};

export default SocialNetworkContainer;
